/** @format */

import React from "react";
import { Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useLocale } from "../i18n/hooks";
// See ModuleNotFound.scss for styles

type Props = {
  itemName: string;
};

const PageNotFound: React.FC<Props> = ({ itemName }) => {
  const locale = useLocale();
  const { t: _ } = useTranslation();
  const item = _(itemName);

  const pageNotFoundInstructions = {
    en: (
      <>
        <h3>{item} not found.</h3>
        <p>We couldn't find the {item.toLowerCase()} you were looking for.</p>
        <p>Please check the URL and try again.</p>
      </>
    ),
    cy: (
      <>
        <h3>Methu â dod o hyd i'r {item.toLowerCase()}.</h3>
        <p>
          Mi fethon ni â dod o hyd i'r {item.toLowerCase()} yr oeddech yn
          chwilio amdani.
        </p>
        <p>Gwiriwch yr URL a thrïwch eto.</p>
      </>
    ),
  };

  return (
    <div className="PageNotFound m-5 col text-center">
      <Card border="light" className="shadow">
        <Card.Body>{pageNotFoundInstructions[locale]}</Card.Body>
      </Card>
    </div>
  );
};

export default PageNotFound;
